/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReferenceEntity { 
    type: ReferenceEntity.TypeEnum;
}
export namespace ReferenceEntity {
    export type TypeEnum = 'actividad' | 'evento' | 'empresa';
    export const TypeEnum = {
        Actividad: 'actividad' as TypeEnum,
        Evento: 'evento' as TypeEnum,
        Empresa: 'empresa' as TypeEnum
    };
}


